import { SVGProps } from 'react';

import { LogoMark, useLogoGradientId } from './logo-mark';

export const LogoIcon = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useLogoGradientId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 104 104" {...props}>
      <LogoMark gradientId={gradientId} />
    </svg>
  );
};
